// extracted by mini-css-extract-plugin
export var chevronIcon = "_sr-1";
export var edgeToggle = "_sr-0";